// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__x3Gtm","prevArrow":"style_prevArrow__MbDoH","bold":"style_bold__PAk73"};